/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 5 minutes enough rest between HIIT sets?`)
};

const es_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son 5 minutos suficiente descanso entre series de HIIT?`)
};

const de_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind 5 Minuten genug Pause zwischen HIIT-Sätzen?`)
};

const nl_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 5 minuten genoeg rust tussen HIIT-sets?`)
};

const fr_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 minutes suffisent-elles comme repos entre des séries de HIIT ?`)
};

const it_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 minuti sono un riposo sufficiente tra le serie HIIT?`)
};

const pt_br2_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 minutos são suficientes de descanso entre séries de HIIT?`)
};

const pt_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 minutos são descanso suficiente entre séries de HIIT?`)
};

const ja_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIITのセット間の休憩は5分で十分ですか？`)
};

const zh_timer_u5m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高强度间歇训练组间休息5分钟够吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_faq3_q", locale)
	if (locale === "en") return en_timer_u5m_faq3_q(inputs)
	if (locale === "es") return es_timer_u5m_faq3_q(inputs)
	if (locale === "de") return de_timer_u5m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u5m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u5m_faq3_q(inputs)
	if (locale === "it") return it_timer_u5m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u5m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u5m_faq3_q(inputs)
	return zh_timer_u5m_faq3_q(inputs)
};